<template>
  <div class="contentHeader" v-if="$session.get(`${$config.appId}_jwt`)"
    v-on:click="headerClicked">
    <div class="menuToggle" v-if="!canGoBack"
      v-on:click="$emit('toggleMenu')"></div>
    <div class="backBtn" v-else v-on:click="$router.go(-1)"></div>

    <h4>{{title}}</h4>
    <div class="user">

      <div :class="{userPict: true, hasPhoto: $session.get(`${$config.appId}_avatar`)}"
        :style="{'background-image': `url('${$session.get(`${$config.appId}_avatar`)}')`}"
        v-on:click="openUserMenu">
        <span v-if="$session.get(`${$config.appId}_name`)">
          {{$session.get(`${$config.appId}_name`).substr(0,2)}}</span>
      </div>
      <div class="userMenuCnt" v-if="userOpen">
        <div class="userOverlay" v-on:click="userOpen = false"></div>
        <div class="userMenu">
          <div class="userMenuHeader">
            <div :class="{userPict: true, hasPhoto: $session.get(`${$config.appId}_avatar`)}"
              :style="{'background-image': `url('${$session.get(`${$config.appId}_avatar`)}')`}">
              <span v-if="$session.get(`${$config.appId}_name`)">
                {{$session.get(`${$config.appId}_name`).substr(0,2)}}</span>
            </div>
            <h4>{{$session.get(`${$config.appId}_name`)}}</h4>
            <p>{{$session.get(`${$config.appId}_email`)}}</p>
          </div>
          <ul>
            <li>
              <a href="https://account.dddtl.net" class="menuItem">
                DDDTL Account
              </a>
            </li>
            <li>
              <a href="https://account.dddtl.net/organizations" class="menuItem">
                Manage Organization
              </a>
            </li>
            <li class="divider"></li>
            <div class="loadingOrg" v-if="loadingOrg"></div>
            <div class="orgCnt" v-else>
              <li v-for="(item, i) in organizations" :key="`st${i}`">
                <div class="menuItem org" :class="{selected: orgId
                  && item.organization && orgId === item.organization.id}"
                  v-on:click="selectOrg(item.organization)">
                  <div class="orgPict hasPhoto" v-if="item.organization.avatar"
                    :style="{'background-image': `url(${item.organization.avatar.imageSm})`}"></div>
                  <div class="orgPict" v-else-if="item.organization.initial">
                    {{item.organization.initial}}
                  </div>
                  <div class="orgPict" v-else-if="item.organization.name">
                    {{item.organization.name.substring(0,2)}}
                  </div>
                  <div class="orgPict" v-else>?</div>
                  {{item.organization.name}}
                  <div class="selected"></div>
                </div>
              </li>
              <li><div class="createOrg"
                v-on:click="createOrg">
                Create Organization</div></li>
              <li><div class="createOrg joinOrg"
                v-on:click="joinOrg">
                Join Organization</div></li>
            </div>
            <li class="divider"></li>
            <li><span v-on:click="openSignOut" class="menuItem red">Sing Out</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="langSelectorBtn"
      v-on:click.stop="langSelectorOpen = !langSelectorOpen">
      <b>{{lang}}</b>
      <div class="langSelectorOverlay" v-if="langSelectorOpen"
        v-on:click.stop="langSelectorOpen = false"></div>
      <div class="langSelector" v-if="langSelectorOpen"
        v-on:click.stop="doNothing">
        <li v-on:click.stop="selectLang('en')">EN - English</li>
        <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
      </div>
    </div>

    <div class="notif">
      <div class="notifIcon" v-on:click.stop="getNotif"></div>
      <div class="unread" v-if="unread > 0">{{unread}}</div>
      <div class="notifOverlay" v-if="notifOpen"
        v-on:click.stop="notifOpen = false"></div>
      <div class="notifCnt" v-if="notifOpen" v-on:click.stop="doNothing">
        <div class="notifHeader">
          Notification
        </div>
        <div class="notifLoading" v-if="loadingNotif"></div>
        <div class="noNotif" v-else-if="allNotif.length < 1">
          <img src="../assets/no-notif.png">
          <h4>No Notification</h4>
          <p>All notification will show up here</p>
        </div>
        <div v-else class="theNotif">
          <div class="notifItem" v-for="(item, i) of allNotif" :key="i"
            v-on:click.stop="openNotif(item)"
            :class="item.icon">
            <span class="timestamp">{{item.timestamp | moment('from', 'now')}}</span>
            {{item.message}}
            <div v-if="item.type === 'download'">
              <div class="btn btnSecondary">Download</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notif app-swicther">
      <div class="notifIcon" v-on:click.stop="appSwitcherOpen = !appSwitcherOpen"></div>
      <div class="notifOverlay" v-if="appSwitcherOpen"
        v-on:click.stop="appSwitcherOpen = false"></div>
      <div class="notifCnt" v-if="appSwitcherOpen" v-on:click.stop="doNothing">
        <div class="notifHeader">
          DDDTL Applications
        </div>
        <div class="theNotif appItemCnt">
          <a href="https://app.cmsriver.com" class="appItem active">
            <div class="appIcon">
              <img src="../assets/cmsriver-logo.png">
            </div>
            <div class="appInfo">
              <h4>CMSRiver</h4>
              <p>Content publications</p>
            </div>
          </a>
          <a href="https://ft.dddtl.net" class="appItem">
            <div class="appIcon">
              <img src="../assets/dddtl-ft-logo.png">
            </div>
            <div class="appInfo">
              <h4>File Transfer</h4>
              <p>Transfer file with ease</p>
            </div>
          </a>
          <a href="https://app.storefront.id" class="appItem">
            <div class="appIcon">
              <img src="../assets/storefront-logo.png">
            </div>
            <div class="appInfo">
              <h4>Storefront</h4>
              <p>Money tracking and bookeeping</p>
            </div>
          </a>
          <a href="https://account.dddtl.net" class="appItem">
            <div class="appIcon">
              <img src="../assets/dddtl-logo.png">
            </div>
            <div class="appInfo">
              <h4>DDDTL Account</h4>
              <p>Account management</p>
            </div>
          </a>
        </div>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <LoadingDialog ref="loadingDialog"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

const { nanoid } = require('nanoid');

export default {
  name: 'contentHeader',
  components: { Confirmation, LoadingDialog },
  data() {
    return {
      userOpen: false,
      loadingNotif: true,
      notifOpen: false,
      appSwitcherOpen: false,
      allNotif: [],
      unread: 0,
      langSelectorOpen: false,
      loadingOrg: true,
      organizations: [],
      orgId: null,
    };
  },
  computed: {
    ...mapState(['title', 'canGoBack', 'lang']),
  },
  methods: {
    ...mapActions(['chLang']),
    doNothing() {},
    headerClicked() {
      this.langSelectorOpen = false;
      this.notifOpen = false;
    },
    openUserMenu() {
      this.userOpen = true;
      this.getOrgs();
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.chLang(lang);
    },
    openSignOut() {
      this.$session.destroy();
      const nonce = nanoid(8);
      const uri = `${this.$config.authLogoutUri}?client_id=${this.$config.authClientId}&nonce=${nonce}`;
      window.location.href = uri;
    },
    openNotif(item) {
      this.notifOpen = false;
      if (item.type === 'download') {
        if (!item.data || !item.data.url) return;
        const link = document.createElement('a');
        link.setAttribute('download', '');
        link.setAttribute('target', '_blank');
        link.href = item.data.url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    getNotif() {
      this.loadingNotif = true;
      this.notifOpen = true;
      this.$http.get(this.$config.uri('user/notifications')).then((r) => {
        this.loadingNotif = false;
        this.allNotif = (r.data.status === 200) ? r.data.data : [];
        this.countUnread();
      });
    },
    countUnread() {
      this.$http.get(this.$config.uri('user/notifications/count')).then((r) => {
        this.loadingNotif = false;
        this.unread = (r.data.status === 200) ? r.data.count : 0;
      });
    },

    /**
     * Organization management
     *
     */
    createOrg(e, inputs) {
      const theIpnuts = inputs || [
        {
          type: 'text',
          label: 'Name',
          placeholder: 'Organization name...',
          error: null,
          value: '',
          required: true,
        },
        {
          type: 'longtext',
          label: 'Descriptions',
          placeholder: 'Organization descriptions...',
          value: '',
        },
      ];
      this.$refs.confirmDialog.open({
        title: 'New Organization',
        desc: 'Please add organization information below.',
        action: 'Save Organization',
        inputs: theIpnuts,
      }, (b, c) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.post(this.$config.uri('org/save'), {
          name: c[0].value,
          descriptions: c[1].value,
        }).then((r) => {
          this.$refs.loadingDialog.close();
          this.getOrgs();
        }).catch((err) => {
          this.$refs.loadingDialog.close();
          theIpnuts[0].value = c[0].value;
          theIpnuts[1].value = c[1].value;
          theIpnuts[0].error = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : 'Internal server error, please try again later';
          this.createOrg(e, theIpnuts);
        });
      });
    },
    joinOrg(e, inputs) {
      const theIpnuts = inputs || [
        {
          type: 'text',
          label: 'Invitation Code',
          placeholder: 'Invitation code...',
          error: null,
          value: '',
          required: true,
        },
      ];
      this.$refs.confirmDialog.open({
        title: 'Join Organization',
        desc: 'Please input organization invitation code. If you dont have an invitation code '
          + 'you can ask organization owner to create new invitation code.',
        action: 'Join Organization',
        inputs: theIpnuts,
      }, (b, c) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.post(this.$config.uri('org/join'), {
          code: c[0].value,
        }).then((r) => {
          /**
           * Set organization id and reload
           *
           */
          this.$session.set(`${this.$config.appId}_org`, r.data.id);
          window.location.reload();
        }).catch((err) => {
          this.$refs.loadingDialog.close();
          theIpnuts[0].value = c[0].value;
          theIpnuts[0].error = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : 'Internal server error, please try again later';
          this.joinOrg(e, theIpnuts);
        });
      });
    },
    getOrgs() {
      this.$http.get(this.$config.uri('user/organizations')).then((r) => {
        this.loadingOrg = false;
        this.organizations = r.data.data;
      }).catch((err) => {
        this.loadingOrg = false;
      });
    },
    selectOrg(org) {
      if (org.id === this.orgId) {
        this.userOpen = false;
        return;
      }
      this.$refs.loadingDialog.open();
      this.$session.set(`${this.$config.appId}_org`, org.id);
      this.$http.patch(this.$config.uri(`user/organization/${org.id}/select`)).then((r) => {
        window.location.reload();
      });
    },
  },
  mounted() {
    if (notifTimer) clearInterval(notifTimer);
    notifTimer = setInterval(() => {
      this.countUnread();
    }, 15000);

    /**
     * Check status
     *
     */
    // if (this.$session.get(`${this.$config.appId}_jwt`) && this.$session.get(`${this.$config.appId}_org`)) {
    if (this.$session.get(`${this.$config.appId}_jwt`)) {
      this.$http.get(this.$config.uri('user/status')).then((r) => {
        if (r.data.status !== 200) {
          this.$session.destroy();
          window.location.reload();
          return;
        }
        console.info('Logged in!'); // eslint-disable-line
      }).catch((err) => {
        this.$session.destroy();
        window.location.reload();
      });
    }

    this.orgId = Number(this.$session.get(`${this.$config.appId}_org`));
    this.getOrgs();
  },
};
</script>

<style scoped lang="scss">
  .contentHeader{
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 4px 20px;
    // background-color: #f5f5f5;
    border-bottom: #eee 1px solid;
    z-index: 9;
    background-color: #fff;
  }
  .backBtn,
  .menuToggle{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url(../assets/menu.png);
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1;
    float: left;
    margin-right: 10px;
    cursor: pointer;
  }
  .backBtn{
    background-image: url(../assets/back-arrow.png);
  }
  .menuToggle:hover{
    background-color: #e5e5e5;
  }
  h4{
    color: #444;
    font-size: 20px;
    font-weight: normal;
    margin: 0;
  }
  .langSelectorBtn{
    margin-right: auto;
    position: absolute;
    right: 156px; top: 8px;
    border-radius: 6px;
    padding: 6px 16px;
    padding-left: 36px;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      background-color: #f5f5fe;
    }
    &:before{
      content: "";
      position: absolute;
      left: 12px; top: 0; bottom: 3px;
      width: 18px;
      background-image: url(../assets/language.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    b{
      font-weight: 600;
      text-transform: uppercase;
    }
    .langSelectorOverlay{
      position: fixed;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 3;
    }
    .langSelector{
      position: absolute;
      background-color: #fff;
      z-index: 7;
      top: 100%; right: -10px;
      box-shadow: 0 0 6px rgba(0, 0, 0, .2);
      border-radius: 5px;
      padding: 8px 0;
      text-align: left;
      li{
        white-space: nowrap;
        list-style: none;
        padding: 8px 24px;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #f5f5fe;
        }
      }
    }
  }

  .notif{
    width: 39px; height: 39px;
    top: 4px; right: 116px;
    position: absolute;
    border-radius: 50%;
    cursor: pointer;
    .notifIcon{
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: url(../assets/notification.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .7;
    }
    .unread{
      background-color: red;
      color: #fff;
      font-size: 10px;
      position: absolute;
      padding: 1px 6px 3px;
      border-radius: 50px;
      top: 0; right: 0;
    }
    .notifOverlay{
      position: fixed;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 981;
      cursor: default;
    }
    .notifCnt{
      position: absolute;
      width: 380px;
      right: 0; top: 100%;
      background-color: #fff;
      box-sizing: border-box;
      z-index: 991;
      padding: 0 0 10px;
      border-radius: 5px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
      cursor: default;
      .notifLoading{
        height: 200px;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
      }
      .noNotif{
        padding: 60px 0;
        text-align: center;
        img{
          height: 64px;
          margin: 0 0 16px;
        }
        h4{
          margin: 0 0 4px;
          font-size: 18px;
          font-weight: 600;
        }
        p{
          margin: 0;
          font-size: 14px;
        }
      }
      .notifHeader{
        padding: 16px 20px 10px;
        border-bottom: #eee 1px solid;
        font-weight: 600;
        font-size: 18px;
      }
      .theNotif{
        max-height: 400px;
        overflow-y: auto;
      }
      .notifItem{
        padding: 10px 20px;
        padding-left: 60px;
        position: relative;
        cursor: pointer;
        .timestamp{
          display: block;
          color: #767676;
          font-size: 13px;
          margin: 0 0 2px;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          left: 20px; top: 24px;
          width: 30px; height: 30px;
          border-radius: 50%;
          background-color: #ffdbe4;
          background-image: url(../assets/notifications_black_24dp.svg);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        &.download_order{
          &:before{
            background-image: url(../assets/notif-icon-order.svg);
          }
        }
        &.download_report{
          &:before{
            background-color: #d9faff;
            background-image: url(../assets/notif-icon-report.svg);
          }
        }
        &.download_delivery{
          &:before{
            background-color: #d3e5ff;
            background-image: url(../assets/notif-icon-delivery.svg);
          }
        }
        .btn{
          border-radius: 50px;
          border: #0747a6 1px solid;
          font-weight: 600;
          display: inline-block;
          font-size: 15px;
          padding: 5px 16px;
          margin: 6px 0 8px;
          padding-left: 34px;
          position: relative;
          background-color: #fff;
          transition: all .3s ease;
          &:before{
            position: absolute;
            content: "";
            display: block;
            width: 20px; left: 10px; top: 0; bottom: 1px;
            background-image: url(../assets/download-o-blue.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
    &.app-swicther{
      right: 74px;
      .notifIcon{
        background-image: url(../assets/app-switcher.png);
      }
    }
  }
  .notif:hover{
    background-color: #e5e5e5;
  }

  .user{
    position: absolute;
    right: 20px;
    top: 4px;
    width: 39px;
    height: 39px;
    .userPict{
      position: absolute;
      right: 0; top: 0;
      width: 39px; height: 39px;
      background-color: #ec174c;
      // background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      font-weight: 600;
      font-size: 18px;

      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-transform: uppercase;
      line-height: 0;
      &.hasPhoto{
        span{
          display: none;
        }
      }
    }
  }
  .userMenuCnt{
    position: relative;
    .userOverlay{
      position: fixed;
      top: 0; right: 0; left: 0; bottom: 0;
      z-index: 1;
    }
    .userMenu{
      position: absolute;
      top: 40px;
      right: -10px;
      z-index: 9;
      background: #fff;
      box-shadow: 2px 2px 8px rgba(0,0,0,.2);
      padding: 15px 0;
      border-radius: 5px;
      width: 340px;
      .userMenuHeader{
        text-align: center;
        padding: 20px 24px 10px;
        border-bottom: #eee 1px solid;
        margin-bottom: 10px;
        .userPict{
          position: static;
          margin: 0 auto 10px;
          width: 80px; height: 80px;
          font-size: 34px;
        }
        h4{
          margin: 0;
          font-size: 22px;
          font-weight: 600;
        }
        p{
          margin: 0;
          color: #767676;
          font-size: 17px;
          padding-bottom: 14px;
        }
      }
      ul{
        margin: 0;
        padding: 0;
        .loadingOrg{
          height: 120px;
          background-image: url(../assets/loading-2.svg);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 36px auto;
        }
        .orgCnt{
          max-height: 360px;
          box-sizing: border-box;
          overflow: auto;
          margin: -5px 0;
          padding: 5px 0;
        }
        li{
          list-style: none;
          .menuItem{
            color: #444;
            display: block;
            padding: 8px 24px;
            font-size: 17px;
            cursor: pointer;
            &.red{
              color: red;
            }
            &.org{
              position: relative;
              padding: 14px 30px;
              margin: 0 0 1px;
              padding-left: 74px;
              font-weight: 600;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              .selected{
                display: none;
                position: absolute;
                background-color: #0e5dd2;
                width: 18px; height: 18px;
                border-radius: 50%;
                background-image: url(../assets/checked.png);
                background-size: 16px auto;
                background-position: 3px 0px;
                background-repeat: no-repeat;
                right: 24px; top: 50%;
                transform: translateY(-50%);
              }
              &.selected{
                background-color: #eef5ff;
                .selected{
                  display: block;
                }
              }
              .orgPict{
                position: absolute;
                width: 36px; height: 36px;
                border-radius: 50%;
                background-color: #0e5dd2;
                color: #fff;
                font-weight: 600;
                // border-radius: 7px;
                text-transform: uppercase;
                font-size: 18px;
                left: 24px; top: 7px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-size: cover;
                background-position: center;
                &.hasPhoto{
                  background-color: transparent;
                }
              }
            }
          }
          .createOrg{
            position: relative;
            border: #fff 1px solid;
            border-radius: 50px;
            padding: 6px 16px 7px;
            padding-left: 34px;
            color: #0e5dd2;
            display: inline-block;
            margin: 4px 24px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
              border-color: #0e5dd2;
            }
            &:before{
              content: "";
              position: absolute;
              left: 6px; top: 6px;
              width: 20px; height: 20px;
              background-image: url(../assets/plus-circle.png);
              background-size: 20px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.joinOrg{
              margin-top: 0;
              margin-bottom: 8px;
              &:before{
                background-image: url(../assets/login-blue.png);
                left: 4px;
              }
            }
          }
        }
        li.divider{
          border-bottom: #eee 1px solid;
          padding-top: 5px;
          margin-bottom: 5px;
        }
        li:hover{
          .menuItem{
            background-color: #f5f5fe;
          }
        }
      }
    }
  }

  .appItemCnt{
    padding: 10px 0 0;
  }
  .appItem{
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-radius: 5px;
    margin: 0 5px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5fe;
    }
    &.active{
      background-color: #bdd8ff !important;
    }
    .appIcon{
      flex: none;
      img{
        height: 40px;
      }
    }
    .appInfo{
      width: 100%;
      padding-left: 20px;
      box-sizing: border-box;
      h4{
        font-size: 17px;
        font-weight: 600;
        margin: 0;
      }
      p{
        margin: 0;
        font-size: 14px;
        color: #767676;
        font-weight: normal;
      }
    }
  }
</style>
